__turbopack_context__.v({
  "desktopOnly": "ResponsiveImage-module__wNMLIG__desktopOnly",
  "mobileOnly": "ResponsiveImage-module__wNMLIG__mobileOnly",
});
